import { useState } from 'react';
import { mockRecommendedHabits } from '@/mocks/userData';

interface AddedToast {
  name: string;
  visible: boolean;
}

export default function RecommendCard() {
  const [idx, setIdx] = useState(0);
  const [addedIds, setAddedIds] = useState<Set<string>>(new Set());
  const [toast, setToast] = useState<AddedToast>({ name: '', visible: false });

  const habit = mockRecommendedHabits[idx % mockRecommendedHabits.length];
  const isAdded = addedIds.has(habit.id);

  const handleSwitch = () => {
    setIdx(i => (i + 1) % mockRecommendedHabits.length);
  };

  const handleAdd = () => {
    if (isAdded) return;
    setAddedIds(prev => new Set([...prev, habit.id]));
    setToast({ name: habit.name, visible: true });
    setTimeout(() => setToast(t => ({ ...t, visible: false })), 2200);
  };

  return (
    <div className="px-4 mb-4 relative">
      {/* 加入成功 Toast */}
      {toast.visible && (
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-full z-50 px-4 py-2 rounded-full text-sm whitespace-nowrap"
          style={{
            background: 'rgba(168,184,216,0.95)',
            color: '#fff',
            backdropFilter: 'blur(8px)',
            marginTop: -8,
          }}
        >
          <i className="ri-checkbox-circle-line mr-1.5" />
          已将「{toast.name}」加入打卡任务
        </div>
      )}

      <div className="flex items-center justify-between mb-2">
        <span className="font-semibold text-sm" style={{ color: '#3D3D3D' }}>为你推荐</span>
        <button onClick={handleSwitch} className="text-xs cursor-pointer whitespace-nowrap" style={{ color: '#C5B9D8' }}>
          换一换
        </button>
      </div>
      <div
        className="rounded-2xl p-4 flex items-center gap-3 relative overflow-hidden"
        style={{
          background: 'rgba(255,255,255,0.72)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          border: '1px solid rgba(181,198,224,0.25)',
        }}
      >
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: 'linear-gradient(135deg, rgba(181,198,224,0.1) 0%, rgba(197,185,216,0.06) 100%)' }}
        />
        <div
          className="w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ background: 'rgba(181,198,224,0.22)' }}
        >
          <i className={`${habit.icon} text-lg`} style={{ color: '#A8B8D8' }} />
        </div>
        <div className="flex-1">
          <p className="font-semibold text-sm" style={{ color: '#3D3D3D' }}>{habit.name}</p>
          <span
            className="inline-block mt-1 px-2 py-0.5 rounded-full text-xs"
            style={{ background: 'rgba(197,185,216,0.2)', color: '#A8B8D8' }}
          >
            {habit.duration}
          </span>
        </div>
        <button
          onClick={handleAdd}
          className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 cursor-pointer active:scale-90 transition-all"
          style={{
            background: isAdded
              ? 'rgba(181,198,224,0.3)'
              : 'linear-gradient(135deg,#B5C6E0,#C5B9D8)',
          }}
        >
          {isAdded
            ? <i className="ri-check-line text-lg" style={{ color: '#A8B8D8' }} />
            : <i className="ri-add-line text-white text-lg" />
          }
        </button>
      </div>
    </div>
  );
}
